"use client";

import { CircleHelp } from "lucide-react";
import { Modal } from "@/components/modal";
import { Button } from "@/components/button";

export const PricingComparisonFeatureModal = ({ feature }) => {
  if (!feature.description) return null;

  return (
    <Modal
      trigger={({ setOpen }) => (
        <Button
          className="w-3 h-3 ml-3 p-0 rounded-full"
          variant="ghost"
          onClick={() => setOpen(true)}
        >
          <CircleHelp size={12} aria-hidden="true" />
        </Button>
      )}
    >
      <div
        className="prose text-left p-10"
        dangerouslySetInnerHTML={{ __html: feature.description }}
      />
    </Modal>
  );
};
